<template>
  <div class="box">
    <div v-infinite-scroll="load" infinite-scroll-immediate="false" class="infinite-list" :style="{height:height}">
      <el-image class="top_img"
        :src="gtype=='gm'?'https://bhres.39bh.com/promote_zs_static/gm_top.jpg':'https://bhres.39bh.com/promote_zs_static/gao_banner.jpg'"
        mode="aspectFit" />
      <div class="img_desc">
      </div>
      <div v-for="(v,k) in list" :key="k" class="con_box" @click="jumpPage(v.game_url)">
        <div class="info_box">
          <el-image class="game_img" :src="v.icon" mode="aspectFit" />
          <div class="info">
            <div class="name_suffix">
              <div class="name">{{ v.relation_game_name }}</div>
              <div v-if="v.game_suffix" class="suffix">{{ v.game_suffix }}</div>
            </div>
            <div class="type_nums">
              <div v-if="v.game_type_name" class="type_box">
                <div v-for="(item,index) in v.game_type_name.split(',')" :key="index" class="type">{{ item }}</div>
              </div>
              <div class="nums">{{ v.dow_num }}人在玩</div>
            </div>
            <div class="tag_box">
              <div v-for="(item,index) in v.tag_name" :key="index" class="tag">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="wxqq" class="modal_box">
      <el-image mode="widthFix" src="https://bhres.39bh.com/android.png" class="" />
    </div>
  </div>

</template>

<script>
  import {
    get_highscore_game_list,
    gm_game_list
  } from '@/api/game.js'
  export default {
    name: 'discount',
    components: {

    },
    data() {
      return {
        list: [],
        box: [],
        device: /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) ?
          'mobile' : 'pc',
        params: {
          page: 1,
          limit: 10,
          promote_id: this.$route.query.promote_id,
          sdk_version: 1
        },
        loading: false,
        finished: false,
        wxqq: false,
        height: '100vh',
        gtype: ''
      }
    },
    computed: {

    },
    created() {
      if (this.$route.query.type == 'gm') {
        document.title = 'GM游戏'
        this.gtype = 'gm'
      } else {
        document.title = '0.1折游戏'
      }
      this.getList()
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        // return "weixin";
        this.wxqq = true
      } else if (ua.match(/QQ/i) == 'qq') {
        // return "QQ";
        this.wxqq = true
      }
    },
    mounted() {


      var isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      this.params.sdk_version = isiOS === true ? 2 : 1
      if (this.device === 'pc') {
        this.height = '911px'
      }
    },
    methods: {
      async getList() {
        let requestUrl = this.gtype == 'gm' ? gm_game_list : get_highscore_game_list
        await requestUrl(this.params).then(res => {
          const {
            list,
            box
          } = res.data
          this.box = box
          console.log(list)
          this.list = this.list.concat(list)
          if (res.data.list.length < this.params.limit) {
            this.finished = true
          }
        })
      },
      load() {
        this.loading = true
        if (this.finished === false) {
          this.params.page++
          this.getList()
        }
      },
      jumpPage(url) {
        if (this.params.sdk_version === 2) {
          window.location.href = url
        } else {
          window.open(url, '_blank')
        }
      }
    }
  }
</script>
<style>
  page {
    /* background-color: #f5f6f8; */
  }
</style>
<style lang="less" scoped>
  .modal_box {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, .6);
  }

  .box {
    display: flex;
    flex-direction: row;
    height: 100%;
    overflow-y: hidden;
    overflow-x: hidden;
    width: 100%;

    .infinite-list::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 8px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    .infinite-list::-webkit-scrollbar-thumb {
      /*滚动条里面小方块--纯色*/
      /*border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(23,161,230,1);*/
      /*滚动条里面小方块--变化色*/
      border-radius: 8px;
      background-color: skyblue;
      background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent);
    }

    .infinite-list::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #ededed;
    }

    .infinite-list {
      margin: 0 auto;
      width: 400px;
      flex-shrink: 0;
      background-color: white;
      overflow: auto;
      /*    height: 911px;*/

      .top_img {
        width: 100%;
        height: 232px;
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
      }

      .img_desc {
        font-size: 15px;
        padding-left: 32px;
        line-height: 54px;
      }

      .con_box {
        background-color: #fff;
        border-radius: 10px;
        padding: 10px 13px 13px;
        margin-top: 16px;
        width: 379px;
        box-sizing: border-box;

        .info_box {
          display: flex;
          width: 351px;

          .game_img {
            width: 74px;
            height: 74px !important;
            border-radius: 16px;
          }

          .info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 246px;

            .name_suffix {
              display: flex;
              align-items: center;
              font-size: 15px;

              .baokuan {
                width: 20px;
                height: 24px !important;
                margin-right: 10px;
                flex-shrink: 0;
              }

              .name {
                font-weight: 700;
                margin-right: 10px;
                white-space: nowrap;
                font-size: 16px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .suffix {
                color: #946328;
                border-radius: 3px;
                font-size: 12px;
                padding: 0 4px;
                vertical-align: text-bottom;
                border: 1px solid #e3b579;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                line-clamp: 1;
                -webkit-box-orient: vertical;
                flex-shrink: 0;
              }
            }

            .type_nums {
              display: flex;
              color: #999;
              font-size: 15px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 266px;

              .type_box {
                display: flex;

                .type {
                  margin-right: 5px;
                }
              }

              .nums {
                padding-left: 5px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .tag_box {
              display: flex;
              font-size: 10px;
              color: #21a9ff;

              .tag {
                margin-right: 5px;
                border: 1px solid;
                padding: 3px 5px;
                border-radius: 3px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 10px;
                text-align: center;

                &:nth-child(1) {
                  color: #ffab47;
                  background-color: #fff0de;
                  border-color: #fdb968;
                  flex-shrink: 0;
                }

                &:nth-child(2) {
                  color: #21a9ff;
                  background-color: #aeddfb;
                  border-color: #69bff6;
                  flex-shrink: 0;
                }

                &:nth-child(3) {
                  color: #ff6551;
                  background-color: #fbcfc9;
                  border-color: #ffa397;
                  margin-right: 0;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/discount/index.vue